import React, {Component, Fragment} from 'react';

import { HeartIcon } from '../../../../../../common/icons';

import './PanelPosition.css';
import { inject, observer } from 'mobx-react';

import moment from 'moment';
import MapWithIcons from '../../../../../../common/components/MapWithIcons';

@inject('translationsStore', 'commonStore', 'noticesStore', 'lockbeatStore')
@observer
export default class PanelPosition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      markers: this.createMarkers(props.car)
    }

    this.MapRef = React.createRef();
  }

  createMarkers(car) {
    return [car, ...(car.additionalPositions || []).map(addPos => ({
      plate: car.plate,
      lastPositionPoint: {
        type: "Point",
        coordinates: [addPos.lon, addPos.lat]
      }
    }))];
  }

  markersMapper = car => {
    const [lng, lat] = car.lastPositionPoint.coordinates;
    let marker = {
      ...car,
      //icon: this.getMarkerMapperIcons(car),
      lng,
      lat
    };
    return marker;
  };

  componentDidMount = () => {
    this.MapInstace = this.MapRef.current.wrappedInstance;
  };

  componentDidUpdate(prevProps) {
    // Check if the car prop has changed
    if (prevProps.car !== this.props.car) {
      this.setState({
        markers: this.createMarkers(this.props)
      });
    }
  }


  render() {
    const { car, carAddress, additionalCarAddresses, commonStore, translationsStore } = this.props;
    return (
      <div className="PanelPosition">
        <div className="left">
          <div className="leftInner">
            <div className={`status ${car.status}`}>
              <div>
                <HeartIcon/>
              </div>
              <div>{translationsStore.translate(`quickFocus.position.status.${car.status}`)}</div>
            </div>
            <div className="position">
              <div>{translationsStore.translate('quickFocus.position.labelStreet')}:</div>
              {carAddress !== false && <div>{(carAddress || {}).label}</div>}
            </div>
            {additionalCarAddresses && additionalCarAddresses.map(addPos => {
              return carAddress !== false && (
                    <div className="position">
                      <div>{translationsStore.translate('quickFocus.position.labelStreetAdditional')}:</div>
                      <div>{addPos.label}</div>
                    </div>
              )
            })}

            <div className="updatedAt">{moment(car.lastConnection).format(commonStore.longDateFormat.LLLL)}</div>
          </div>
        </div>
        <div className="right">
          <MapWithIcons
              notices={this.props.noticesStore.carsHaving}
              imeisWithLockbeat={this.props.lockbeatStore.imeisWithLockbeat}
              ref={this.MapRef}
              onTap={() => false}
            markers={this.state.markers}
            className={`carFocusMap ${!car.lastPositionPoint ? 'withoutPosition' : ''}`}
            markerId="plate"
            getLat={car => car.lastPositionPoint.coordinates[1]}
            getLng={car => car.lastPositionPoint.coordinates[0]}
            style={{
              height: '100%',
              right: '0',
              width: '100%'
            }}
            zoom={this.state.markers.length > 1 ? 6 : 16}
            markersFilter={car => !!car.lastPositionPoint}
            markersMapper={this.markersMapper}
            onMapLoaded={(map) => setTimeout(() => map.resize(), 500)}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/PanelPosition/PanelPosition.js